// Photos compressées en attente d'envoi ; le fichier est supprimé dès que l'API l'a accepté
export const createPhotoStore = (db) => ({
    put: (photo) => db.photos.put({ ...photo, projectId: photo.projectId === null || photo.projectId === undefined ? null : Number(photo.projectId) }),
    get: (id) => db.photos.get(id),
    remove: (id) => db.photos.delete(id),
    listByProject: (projectId) => db.photos.where('projectId').equals(Number(projectId)).toArray()
});
